import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Toast } from "primereact/toast";
import LeadsAssignedService from "../../services/LeadsAssignedService";
import $ from "jquery";
import "datatables.net";
import AuthService from "../../services/AuthService";
import RegisterUserService from "../../services/RegisterUserService";
import { MdRepeat } from "react-icons/md";
import ToastService from "../../services/ToastService";
import LeadService from "../../services/LeadService";
const API_URL = process.env.REACT_APP_API_URL;
import '@fortawesome/fontawesome-free/css/all.min.css';

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

function LeadsAssigned() {
  const [selectedRows, setSelectedRows] = useState(new Set());
  const [selectAll, setSelectAll] = useState(false);
  const [LeadsAssigned, setLeadsAssigned] = useState([]);
  const navigate = useNavigate();
  const toast = useRef(null);
  const [searchTerm] = useState("");
  const tableRef = useRef(null);
  const [employees, setselectedUser] = useState([]);
  const queryParam = useQuery();
  const [selectedValue, setSelectedValue] = useState("");
  const [UserId] = useState(
    queryParam.get("id") || AuthService.getCurrentUser().UserId
  );
  const userRole = AuthService.getLoggedInRoleId();
  const [isEmployeeSelectedError, setIsEmployeeSelectedError] = useState(false);
  const toastService = new ToastService(toast);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [leadStatus, setLeadStatus] = useState([]);
  const savedPageNumber = localStorage.getItem("currentPageNumber")
    ? parseInt(localStorage.getItem("currentPageNumber"))
    : 1;
  const [pageNumber, setPageNumber] = useState(savedPageNumber);
  const pageSize = 10;

  const ClientId = AuthService.getLoggedInClientId();
  const [recordsTotal, setRecordsTotal] = useState(0);
  const [recordsFiltered, setRecordsFiltered] = useState(0);

  useEffect(() => {
    const fetchEmployee = async () => {
      try {
        const users = await RegisterUserService.getEmployessByRoleId(4);
        setselectedUser(users);
      } catch (error) {
        console.error("Error fetching users:", error);
        toastService.showError("Error", "Failed to fetch users data");
      }
    };

    const fetchLeadStatus = async () => {
      try {
        const leadstatus = await LeadService.getAllLeadStatus();
        setLeadStatus(leadstatus);
      } catch (error) {
        console.error("Error fetching lead status:", error);
      }
    };

    fetchLeadStatus();
    fetchEmployee();

    setTimeout(() => {
      $("#tableData").DataTable();
    }, 1000);
  }, [UserId]);

  useEffect(() => {
    if (Notification.permission === "default") {
      Notification.requestPermission();
    }
  }, []);

  const printLead = (leadassigned) => {
    debugger;
    const printWindow = window.open("", "_blank");
    const lead = leadassigned.lead;
    const sourceType = lead
      ? sourceTypes.find((source) => source.id === lead.sourceTypeId)
      : null;
    const sourceTypeName = sourceType ? sourceType.name : "Unknown";
    const leadStatus = LeadStatus.find(
      (leadstatus) => leadstatus.id === leadassigned.leadStatusId
    );
    const leadStatusName = leadStatus ? leadStatus.name : "Unknown";
    const property = PropertyType.find(
      (propertytype) => propertytype.id === leadassigned.propertyTypeId
    );
    const propertyTypeName = property ? property.name : "Unknown";

    printWindow.document.write(`
      <html>
        <head>
          <title>Print Lead</title>
          <style>
            body { font-family: Arial, sans-serif; padding: 20px; }
            table { width: 100%; border-collapse: collapse; }
            th, td { border: 1px solid #ccc; padding: 8px; text-align: left; }
            th { background-color: #f2f2f2; }
          </style>
        </head>
        <body>
          <h2>Lead Details</h2>
          <table> 
            <tr><th>Lead Name</th><td>${
              lead ? `${lead.firstName}` : "Unknown Lead"
            }</td></tr>
            <tr><th>Email</th><td>${
              lead ? lead.email : "Unknown Lead"
            }</td></tr>
            <tr><th>Contact Number</th><td>${
              lead ? lead.contactNumber : "Unknown Lead"
            }</td></tr>
            <tr><th>Lead Start Date</th><td>${
              lead
                ? new Date(lead.startDate).toLocaleString("en-US", {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                    hour12: true,
                  })
                : "Unknown Lead"
            }</td></tr>
            <tr><th>Lead Assigned Date</th><td>${new Date(
              leadassigned.leadAssignedDate
            ).toLocaleString("en-US", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
              hour12: true,
            })}</td></tr>
            <tr><th>Source Type</th><td>${sourceTypeName}</td></tr>
            <tr><th>Lead Status</th><td>${leadStatusName}</td></tr>
            <tr><th>Property Type</th><td>${propertyTypeName}</td></tr>
            <tr><th>Conversation Comments</th><td>${
              leadassigned.conversationComment
            }</td></tr>
          </table>
          <br>
        </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.onload = () => printWindow.print();
  };

  const handleSelectAll = (event) => {
    const isChecked = event.target.checked;
    setSelectAll(isChecked);
    if (isChecked) {
      setSelectedRows(LeadsAssigned.map((lead) => lead.leadId));
    } else {
      setSelectedRows([]);
    }
  };

  const handleChange = (event) => {
    setSelectedValue(event);
    if (event) {
      setIsEmployeeSelectedError(false);
    }
  };

  const sourceTypes = [
    { id: 1, name: "Facebook" },
    { id: 2, name: "Instagram" },
    { id: 3, name: "Reference" },
  ];

  $("#tableData").on("change", ".row-checkbox", function () {
    const rowIndex = $(this).data("row");
    const isChecked = $(this).is(":checked");
    const updatedSelection = isChecked
      ? [...selectedRows, rowIndex]
      : selectedRows.filter((index) => index !== rowIndex);
    setSelectedRows(updatedSelection);
  });

  const ReAssignLead = async () => {
    if (!selectedValue) {
      toastService.showWarning(
        "Warning",
        "Please select an employee to re-assign the lead"
      );
      return;
    }
    if (selectedRows.length === 0) {
      toastService.showWarning(
        "Warning",
        "Please select at least one lead to re-assign"
      );
      return;
    }

    try {
      await LeadsAssignedService.ReAssignedLeads(
        selectedValue,
        Array.from(selectedRows)
      );
      toastService.showSuccess("Success", "Lead Re-Assigned successfully");
      setSelectedValue("");
      setSelectedRows(new Set());
      if ($.fn.DataTable.isDataTable(tableRef.current)) {
        const table = $(tableRef.current).DataTable();
        table.ajax.reload(null, false); // This will reload the data and preserve the current page (false means do not reset to page 1)
      }
    } catch (error) {
      toastService.showError("Error", "Failed to Assign lead");
    }
  };

  

  function getStatusClass(leadStatusName) {
    switch (leadStatusName) {
      case "AssignedToEmployee":
        return "badge badge-sm bg-gradient-success";
      case "Interested":
        return "badge badge-sm bg-gradient-success";
      case "HotClient":
        return "badge badge-sm bg-gradient-danger";
      case "NotInterested":
        return "badge badge-sm bg-gradient-secondary";
      case "CallBackLater":
        return "badge badge-sm bg-gradient-dark";
      case "InvalidNumber":
        return "badge badge-sm bg-gradient-light";
      case "Complete":
        return "badge badge-sm bg-gradient-secondary";
      case "Visited":
        return "badge badge-sm bg-gradient-primary";
      case "Upcoming Visit":
        return "badge badge-sm bg-gradient-warning";
      default:
        return "";
    }
  }

  const leadStatusMap = {
    1: "AssignedToEmployee",
    2: "HotClient",
    3: "Interested",
    4: "NotInterested",
    5: "PhoneNotPicked",
    6: "InvalidNumber",
    7: "ContactAfterSomeTime",
    8: "CallBackLater",
    9: "Upcoming Visit",
    10: "Complete",
    11: "Visited"
  };

  const Role = {
    SUPERADMIN: { roleId: 1, roleName: "SuperAdmin" },
    ADMIN: { roleId: 2, roleName: "Admin" },
    MANAGER: { roleId: 3, roleName: "Manager" },
    EMPLOYEE: { roleId: 4, roleName: "Employee" },
  };

  const LeadStatus = [
    { id: 1, name: "AssignedToEmployee" },
    { id: 2, name: "HotClient" },
    { id: 3, name: "Interested" },
    { id: 4, name: "NotInterested" },
    { id: 5, name: "PhoneNotPicked" },
    { id: 6, name: "InvalidNumber" },
    { id: 7, name: "ContactAfterSomeTime" },
    { id: 8, name: "CallBackLater" },
    { id: 9, name: "Upcoming Visit" },
    { id: 10, name: "Complete" },
    { id: 11, name: "Visited" },
  ];

  const PropertyType = [
    { id: 1, name: "1BHK" },
    { id: 2, name: "2BHK" },
    { id: 3, name: "3BHK" },
    { id: 4, name: "4BHK" },
    { id: 5, name: "5BHK" },
    { id: 6, name: "Plot" },
    { id: 7, name: "Kothi" },
    { id: 8, name: "Other" },
  ];

  // const handleCheckboxChange = (leadId) => {
  //   const updatedSelectedRows = Array.from(selectedRows);
  //   if (updatedSelectedRows.includes(leadId)) {
  //     setSelectedRows(updatedSelectedRows.filter(id => id !== leadId));
  //   } else {
  //     setSelectedRows([...updatedSelectedRows, leadId]);
  //   }
  // };

  const handleCheckboxChange = (leadId) => {
    const updatedSelectedRows = new Set(selectedRows);
    if (updatedSelectedRows.has(leadId)) {
      updatedSelectedRows.delete(leadId);
    } else {
      updatedSelectedRows.add(leadId);
    }
    setSelectedRows(updatedSelectedRows);
  };

  useEffect(() => {
    const token = AuthService.getToken();
    const table = $(tableRef.current).DataTable({
      processing: true,
      serverSide: true,
      displayStart: (savedPageNumber - 1) * pageSize,
      ajax: function (data, callback, settings) {
        const currentPage = Math.floor(data.start / data.length) + 1;
        localStorage.setItem("currentPageNumber", currentPage);
        setPageNumber(currentPage); // optional: in case you use it in UI
        const url = `${API_URL}/LeadAssigned/GetAllLeadAssignedByUserId/${UserId}/${ClientId}/${currentPage}/${pageSize}`;
  
        $.ajax({
          url,
          type: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          success: function (response) {
            console.log("API Response:", response);
  
            callback({
              draw: data.draw,
              recordsTotal: response.value.recordsTotal,
              recordsFiltered: response.value.recordsFiltered,
              data: response.value.data.$values || [],
            });
          },
          error: function (xhr, error, code) {
            console.error("API Request failed:", error, xhr);
            toastService.showError("Error", "Failed to fetch leads data");
          },
        });
      },
      columnDefs: [{ targets: [0], visible: true, searchable: false }],
      columns: [
        {
          data: "leadId",
          name: "Select",
          render: function (data, type, row) {
            debugger;
            const isChecked = selectedRows.has(row.leadId);
            const isDisabled = row.isLeadAssigned;
            return `<input type="checkbox" class="row-checkbox" data-row="${
              row.leadId
            }" ${isDisabled ? "disabled" : ""} ${
              isChecked ? "checked" : ""
            } /> `;
          },
          orderable: false,
          searchable: false,
        },
        {
          data: "conversationComment",
          name: "Conversation Comment",
          autoWidth: true,
        },
        {
          data: null,
          name: "Lead Code",
          render: function (data, type, row) {
            return `<span class="text-secondary text-xs font-weight-bold">${
              row.lead ? row.lead.leadCode : "Unknown Lead"
            }</span>`;
          },
          autoWidth: true,
        },
        {
          data: null,
          name: "First Name",
          render: function (data, type, row) {
            return `<span class="text-secondary text-xs font-weight-bold">${
              row.lead ? row.lead.firstName : "Unknown Lead"
            }</span>`;
          },
          autoWidth: true,
        },
        {
          data: null,
          name: "Contact Number",
          render: function (data, type, row) {
            return `<span class="text-secondary text-xs font-weight-bold">${
              row.lead ? row.lead.contactNumber : "Unknown Lead"
            }</span>`;
          },
          autoWidth: true,
        },
        {
          data: null,
          name: "Source",
          render: function (data, type, row) {
            let iconHtml = "";
            const source = row.lead?.source?.toLowerCase() || "unknown";
        
            if (source === "fb") {
              iconHtml = `<i class="fab fa-facebook-square" style="color:#3b5998; font-size: 1.5rem;" title="Facebook"></i>`;
            } else if (source === "ig") {
              iconHtml = `<i class="fab fa-instagram" style="color:#C13584; font-size: 1.5rem;" title="Instagram"></i>`;
            } else {
              iconHtml = `<span class="text-muted">Unknown</span>`;
            }
        
            return `<span class="text-secondary text-xs font-weight-bold">${iconHtml}</span>`;
          },
          autoWidth: true,
        },
        {
          data: null,
          name: "Lead Status",
          render: function (data, type, row) {
            const status = leadStatusMap[row.leadStatusId] || 'Unknown';
            const statusClass = getStatusClass(status);
            return `<span class="${statusClass}">${status}</span>`;
          },
          autoWidth: true,
        },
        {
          data: null,
          name: "Property",
          render: function (data, type, row) {
            return `<span class="text-secondary text-xs font-weight-bold">${
              row.lead ? row.lead.property : "Unknown Lead"
            }</span>`;
          },
          autoWidth: true,
        },
        {
          data: "leadAssignedDate",
          name: "LeadAssigned Date",
          render: function (data) {
            debugger;
            return new Date(data).toLocaleDateString();
          },
          autoWidth: true,
        },
        {
          data: null,
          name: "Employee Name",
          render: function (data, type, row) {
            return `<span class="text-secondary text-xs font-weight-bold">${
              row.user
                ? row.user.firstName + " " + row.user.lastName
                : "Unknown Lead"
            }</span>`;
          },
          autoWidth: true,
        },
        {
          data: "followUpDate",
          name: "followUpDate",
          render: function (data) {
            debugger;
            return new Date(data).toLocaleDateString();
          },
          autoWidth: true,
        },
        {
          data: "nextUpdate",
          name: "Next Update",
          render: function (data) {
            debugger;
            return new Date(data).toLocaleDateString();
          },
          autoWidth: true,
        },
        {
          data: null,
          render: function (data, type, row) {
            const isAuthorized =
              userRole == Role.SUPERADMIN.roleId ||
              userRole == Role.ADMIN.roleId ||
              userRole == Role.MANAGER.roleId;
            let actions = `
              <button class="btn btn-outline-dark btn-sm edit-lead-btn" data-id="${row.id}">
                <i class="pi pi-pencil" style="font-size: 1.5rem;"></i>
              </button>
            `;
            if (isAuthorized) {
              actions += `
                <button class="btn btn-outline-dark btn-sm print-lead-btn" data-id="${row.id}">
                  <i class="fas fa-print" style="font-size: 1.5rem;"></i>
                </button>
              `;
            }
            return actions;
          },
          orderable: false,
          searchable: false,
        },
      ],
      drawCallback: function (settings) {
  
          $(tableRef.current)
            .find(".row-checkbox")
            .each(function () {
              const leadId = $(this).data("row");
              const rowData = settings.aoData.find(
                (row) => row._aData.leadId === leadId
              );
              if (rowData) {
                const isDisabled = rowData._aData.isLeadAssigned;
                $(this).prop("disabled", isDisabled);
                $(this).prop("checked", selectedRows.has(leadId));
              }
            });
        
        
      },
      stateSave: true,
      
    });
    $(tableRef.current).on("click", ".print-lead-btn", function () {
      const leadId = $(this).data("id");
      const leadassigned = table.row($(this).closest("tr")).data();
      printLead(leadassigned); // Call the printLead function with the leadassigned data
    });
    $(tableRef.current).on("click", ".edit-lead-btn", function () {
      const leadId = $(this).data("id");
      navigate(`/editleadassigned/${leadId}`);
    });
    $(tableRef.current).on("change", ".row-checkbox", function () {
      const leadId = $(this).data("leadId");
      handleCheckboxChange(leadId);
    });
    return () => {
      if ($.fn.DataTable.isDataTable(tableRef.current)) {
        $(tableRef.current).DataTable().destroy();
      }
    };
  }, [UserId,ClientId]);

  return (
    <div>
      {" "}
      <Toast ref={toast} />
      <div class="row">
        {(userRole == Role.SUPERADMIN.roleId ||
          userRole == Role.ADMIN.roleId ||
          userRole == Role.MANAGER.roleId) && (
          <div className="form-group row">
                    <div className="col-lg-5">
                      <div className="form-group row">
                        <div className="col-lg-6">
                        <select
                name="userId"
                id="userId"
                className={`form-control ${
                  isEmployeeSelectedError
                    ? "error"
                    : selectedValue
                    ? "valid"
                    : ""
                }`}
                value={selectedValue}
                onChange={(e) => handleChange(e.target.value)}
              >
                <option value="" disabled>
                  Re-Assign lead(s) to employee{" "}
                </option>
                {employees.map((employee) => (
                  <option key={employee.id} value={employee.id}>
                    {employee.firstName}
                  </option>
                ))}
              </select>
              {isEmployeeSelectedError && (
                <div className="text-danger mt-2">
                  Please select an employee
                </div>
              )}
                        </div>
          
                        <div className="col-lg-6">
                        <a
                class="btn bg-gradient-dark mb-0 "
                href="javascript:;"
                onClick={() => ReAssignLead()}
              >
                <MdRepeat /> Re-Assign Leads
              </a>
                        </div>
                      </div>
                    </div>
          
                    <div className="col-lg-7 form-group row">
                      
                      <div className="col-lg-12">
                      <a
                class="btn bg-gradient-dark mb-0 float-end"
                href="javascript:;"
                onClick={() => navigate("/addleadsassigned")}
              >
                <i className="pi pi-plus"></i> Add Leads
              </a>
                      </div>
                    </div>
                  </div>
        )}

        <div className="p-2 m-2">
          <div class="col-12">
            <div class="card my-4">
              <div class="card-body px-0 pb-2">
                <div class="table-responsive p-0">
                  <table
                    class="table align-items-center mb-0"
                    id="tableData"
                    ref={tableRef}
                  >
                    <thead class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      <tr>
                        {userRole == Role.SUPERADMIN.roleId ||
                        userRole == Role.ADMIN.roleId ||
                        userRole == Role.MANAGER.roleId ? (
                          <th>Select</th>
                        ) : null}
                        <th>Conversation Comments</th>
                        <th>Lead Code</th>
                        <th>Lead Name</th>
                        <th>Contact Number</th>
                        <th>Source</th>
                        <th>Lead Status</th>
                        <th>Property</th>
                        <th>Lead Assigned Date</th>
                        <th>Employee</th>
                        <th>Follow Up</th>
                        <th>Next FollowUp</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody> </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LeadsAssigned;
